type DatadogLogsGlobal = {
  logger: {
    info: (message: string, messageContext?: object) => void;
    error: (message: string, messageContext?: object, error?: Error) => void;
  };
};

// An imported datadogLogs resolves to an uninitialised copy inside a federated microfrontend;
// only the global belongs to the shell's init.
export const getDatadogLogs = (): DatadogLogsGlobal | undefined =>
  (window as unknown as { DD_LOGS?: DatadogLogsGlobal }).DD_LOGS;
